<template>
    <div class="register-page-component-container">
        <div class="component-wrapper">
            <LoginHeader />

            <div class="register-page-container scroll-bar">
                <div class="register-form-container">
                    <div class="form-container">
                        <form class="register-form" @submit="registerNewAccount">
                            <div v-if="$store.registerViaInvitationLink" class="info-text-container">
                                <!-- <p class="info-text">
                                    Jouw trainer heeft je uitgenodigd om aan te melden met:
                                </p> -->
                                <p class="info-text">
                                    {{ $t('trainer_invite_you_to_register') }}
                                </p>
                                <p class="user-email">
                                    {{ $store.user.email }}
                                </p>
                            </div>

                            <div v-else class="info-text-container">
                                <!-- <p class="info-text">
                                    Vul je gegevens in om te registreren
                                </p> -->
                                <p class="info-text">
                                    {{ $t('enter_info_to_register') }}
                                </p>
                            </div>

                            <div v-if="!$store.registerViaInvitationLink" class="input-container">
                                <div class="form-section-wrapper email-section-container">
                                    <!-- <div class="email-input-container"> -->
                                    <!-- <input id="email" class="form-input" name="email" type="text"
                                            placeholder="Vul je email in die bij je trainer bekend is..." required /> -->
                                    <input id="email" class="form-input" name="email" type="text" 
                                        :class="[{'error-unknown-email': unknownEmailAddress || emailAlreadyRegistered, 'blocked': registrationLoading}]"
                                        :placeholder="$t('enter_email_address_known_to_trainer') + '...'" required />
                                    <!-- </div> -->
                                </div>
                                <div v-if="unknownEmailAddress || emailAlreadyRegistered" class="error-msg-unknown-email-container">
                                    <!-- v-if="unknownEmailAddress" -->
                                    <p class="red">{{ $t(`${registrationErrMsg}`) }}</p>
                                </div>
                            </div>

                            <div class="input-container">
                                <div class="form-section-wrapper password-section-container">
                                    <div class="show-hide-password-container" @click="showHidePassword">
                                        <img :src="require(`../../assets/icons/${showPassword ? 'show' : 'hide'}_password.png`)"
                                            alt="password icon">
                                    </div>
                                    <div class="password-input-container">
                                        <!-- <input id="password" class="form-input"
                                            :class="passwordLengthInvalid ? 'error-password-length' : passwordStrength"
                                            name="password" :type="showPassword ? 'text' : 'password'"
                                            @keyup="checkPasswordStrength" @blur="checkPasswordLength"
                                            placeholder="Bedenk nieuw wachtwoord..." required /> -->
                                        <input id="password" class="form-input"
                                            :class="[{ 'blocked': registrationLoading }, passwordLengthInvalid ? 'error-password-length' : passwordStrength]"
                                            name="password" :type="showPassword ? 'text' : 'password'"
                                            @keyup="checkPasswordStrength" @blur="checkPasswordLength"
                                            :placeholder="$t('create_new_password') + '...'" required />
                                    </div>
                                </div>
                                <div v-if="showPasswordMsg" class="password-length-strength-msg-container">
                                    <!-- v-if="unknownEmailAddress" -->
                                    <p :class="passwordMsgColor">{{ $t(`${passwordMsg}`) }}</p>
                                </div>
                            </div>

                            <div class="input-container">
                                <div class="form-section-wrapper">
                                    <!-- <input id="repeat-password" class="form-input"
                                        :class="confirmPasswordNotMatch ? 'error-password-not-match' : ''"
                                        name="repeat-password" type="password" placeholder="Herhaal dit wachtwoord..."
                                        required /> -->
                                    <input id="repeat-password" class="form-input"
                                        :class="[{'error-password-not-match': confirmPasswordNotMatch, 'blocked': registrationLoading}]"
                                        name="repeat-password" type="password"
                                        :placeholder="$t('re_enter_password') + '...'" required />
                                </div>
                                <div v-if="confirmPasswordNotMatch" class="error-msg-password-not-match-container">
                                    <!-- v-if="unknownEmailAddress" -->
                                    <!-- <p class="red">Je wachtwoord komt niet overeen.</p> -->
                                    <p class="red">{{ $t('password_does_not_match') }}</p>
                                </div>
                            </div>

                            <div class="form-section-wrapper register-btn-container">
                                <div class="register-btn-wrapper">
                                    <div v-if="registrationLoading" class="loading-spinner-container">
                                        <!-- <div class="circular-progress-indicator"></div> -->
                                        <div class="spinner">
                                            <img src="../../assets/imgs/loading_spinner.png" alt="Spinner Image">
                                        </div>
                                    </div>
                                    <!-- <input v-else id="register-btn" class="register-btn btn" type="submit"
                                        value="Register" /> -->
                                    <input v-else id="register-btn" class="register-btn btn" type="submit"
                                        :value="$t('register')" />
                                </div>
                                <div class="register-info-msg-container">
                                    <p v-if="(!$store.registerViaInvitationLink && registrationFailed && !unknownEmailAddress && !emailAlreadyRegistered) || ($store.registerViaInvitationLink && registrationFailed)" class="register-info-msg red">
                                        {{ $t(`${registrationErrMsg}`) }}
                                    </p>
                                </div>
                            </div>
                        </form>

                        <div class="can-not-register-text-container">
                            <!-- <p>Lukt het registreren niet?</p> -->
                            <p>{{ $t('cant_register') }}</p>
                            <!-- <p>Vraag hulp bij je fit20 trainer.</p> -->
                            <p>{{ $t('ask_trainer_for_hulp') }}</p>
                        </div>

                        <div class="back-to-login-page-container">
                            <!-- <p>Heb je al een account?</p> -->
                            <p>{{ $t('already_have_account') }}</p>
                            <div class="back-to-login-page-btn-container">
                                <!-- <p @click="goToLoginPage">Terug naar inlog</p> -->
                                <p @click="goToLoginPage">{{ $t('go_to_login') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div v-else class="registration-completed-container">
                    <div class="registration-completed-msg-container">
                        <p v-if="registerType == 'register'">
                            Het registreren is gelukt
                            <br><br>
                            Activeer je account via de bevestigingsmail
                        </p>
                        <p v-if="registerType == 'invite'">You are registered successfully <br> and you can directly login</p>
                    </div>
                    <div class="login-btn-container">
                        <p>Account geactiveerd?</p>
                        <div class="login-btn" @click="goToLoginPage">Login</div>
                    </div>
                </div> -->
            </div>

            <LoginFooter />
        </div>
    </div>
</template>

<script>
import LoginHeader from './LoginHeader.vue';
import LoginFooter from './LoginFooter.vue';
import { passwordStrength } from 'check-password-strength';
export default {
    name: 'RegisterPage',
    components: {
        LoginHeader,
        LoginFooter,
    },
    data() {
        return {
            registerType: '',
            invitationData: {},
            registrationLoading: false,
            registrationFailed: false,
            // registrationFailed: true,
            // registrationSuccesseded: false,
            unknownEmailAddress: false,
            registrationErrMsg: '',
            confirmPasswordNotMatch: false,
            showPasswordMsg: false,
            passwordLengthInvalid: false,
            passwordMsg: '',
            passwordMsgColor: 'red',
            passwordStrength: '',
            showPassword: false,
            emailAlreadyRegistered: false,
        };
    },
    methods: {
        showHidePassword: function () {
            this.showPassword = !this.showPassword;
        },
        displayLoginPage: function () {
            this.$router.push('/login');
        },
        registerNewAccount: async function (e) {
            e.preventDefault();

            const checkPasswordStrengthResponse = this.checkPasswordLength();

            if (checkPasswordStrengthResponse) {
                // The password has 6 characters or more
                this.registrationLoading = false;
                this.registrationFailed = false;
                this.unknownEmailAddress = false;
                this.emailAlreadyRegistered = false;
                this.registrationErrMsg = '';

                const password = document.getElementById("password").value;
                const confirmPassword = document.getElementById("repeat-password").value;

                if (password !== confirmPassword) {
                    this.confirmPasswordNotMatch = true;
                }
                else {
                    const registerBtn = document.getElementById('register-btn');
                    registerBtn.disabled = true;
                    this.registrationLoading = true;

                    let data;

                    // let appLang = 'en';
                    // if (this.$store.appLanguageChangedBeforeLogin && this.$store.selectedAppLanguage != appLang) {
                    //     appLang = this.$store.selectedAppLanguage;
                    // }

                    // appLang = this.$store.selectedAppLanguage;

                    if (this.registerType == 'register') {
                        const email = document.getElementById('email').value;
                        data = {
                            email: email,
                            password: password,
                            registerType: this.registerType,
                            appLang: this.$store.selectedAppLanguage,
                        }
                    }
                    else {
                        data = {
                            email: this.invitationData.email,
                            registerType: this.registerType,
                            token: this.invitationData.token,
                            password: password,
                            appLang: this.$store.selectedAppLanguage,
                        }
                    }

                    // console.log(data);

                    try {
                        let url;
                        if (this.registerType === 'invite') {
                            url = '../../../api/user/register';
                        }
                        else {
                            url = 'api/user/register';
                        }
                        const registerNewAccountResponse = await fetch(url, {
                            method: "POST",
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json; charset=UTF-8',
                            },
                            body: JSON.stringify(data),
                        });

                        const registerNewAccountResponseJson = await registerNewAccountResponse.json();

                        // console.log(registerNewAccountResponseJson);

                        if (!registerNewAccountResponseJson.status) {
                            if (registerNewAccountResponseJson.unknownEmailAddress) {
                                this.unknownEmailAddress = true;
                                // console.log(registerNewAccountResponseJson.message);
                            }
                            else if (registerNewAccountResponseJson.emailAlreadyRegistered) {
                                this.emailAlreadyRegistered = true;
                            }
                            // else {
                            //     this.registrationFailed = true;
                            // }
                            
                            this.registrationFailed = true;
                            this.registrationErrMsg = registerNewAccountResponseJson.message;
                            this.registrationLoading = false;
                            registerBtn.disabled = false;

                            // console.log("this.emailAlreadyRegistered: " + this.emailAlreadyRegistered);
                            // console.log("this.registrationFailed: " + this.registrationFailed);
                        }
                        else {
                            this.$store.registrationCompleted = true;
                            this.$router.push('/confirm');
                        }
                    }
                    catch (err) {
                        console.log(err);
                        this.registrationErrMsg = 'something_went_wrong_try_again';
                        this.registrationFailed = true;
                        registerBtn.disabled = false;
                        this.registrationLoading = false;
                    }
                }
            }
            else {
                this.registrationFailed = true;
                this.registrationErrMsg = 'enter_valid_data';
            }
        },
        checkPasswordStrength: function () {
            this.confirmPasswordNotMatch = false;
            this.showPasswordMsg = false;
            this.passwordLengthInvalid = false;
            this.passwordMsg = '';
            this.passwordStrength = '';
            this.passwordMsgColor = 'red';
            const passwordInput = document.getElementById('password');

            if (passwordInput.value != "") {
                const passwordStrengthResult = passwordStrength(passwordInput.value).value;

                switch (passwordStrengthResult) {
                    case "Too weak":
                    case "Weak": {
                        this.showPasswordMsg = true;
                        this.passwordMsg = 'this_password_weak';
                        this.passwordStrength = 'weak';
                        this.passwordMsgColor = 'red';
                    }
                        break;
                    case "Medium": {
                        this.showPasswordMsg = true;
                        this.passwordMsg = 'this_password_ok';
                        this.passwordStrength = 'medium';
                        this.passwordMsgColor = 'blue';
                    }
                        break;
                    case "Strong": {
                        this.showPasswordMsg = true;
                        this.passwordMsg = 'this_password_strong';
                        this.passwordStrength = 'strong';
                        this.passwordMsgColor = 'green';
                    }
                }
            }
            else {
                this.checkPasswordLength();
            }
        },
        checkPasswordLength: function () {
            if (!this.showPasswordMsg) {
                this.confirmPasswordNotMatch = false;
                this.showPasswordMsg = false;
                this.passwordLengthInvalid = false;
                this.passwordMsg = '';
                this.passwordStrength = '';
                this.passwordMsgColor = 'red';
            }
            const passwordInput = document.getElementById("password");
            if (passwordInput.value.length < 6) {
                this.passwordLengthInvalid = true;
                this.showPasswordMsg = true;
                this.passwordMsg = 'create_password_with_at_least_6_characters';
                return false;
            }
            else {
                return true;
            }
        },
        goToLoginPage: function () {
            this.$store.backToLoginPage();
        },
    },
    async created() {
        // const loggedInUser = await this.$store.checkLoggedinUser();
        // if (loggedInUser) {
        //     this.$router.push('/home');
        // }
        // else {

        // }
    },
    mounted() {
        if (Object.keys(this.$route.params).length > 0) {
            this.registerType = 'invite';
            this.invitationData = this.$route.params;
        }
        else {
            this.registerType = 'register';
        }
    }
};
</script>

<style>
.register-page-component-container {
    position: relative;
    height: 100vh;
    width: 100%;
}

.register-page-component-container .component-wrapper {
    height: 100vh;
    display: flex;
    flex-direction: column;
}

.register-page-component-container .register-page-container {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    align-items: center;
    overflow: auto;
}

.register-page-component-container .register-form-container {
    width: 88%;
    height: 100%;
    max-width: 500px;
    /* min-height: 400px; */
    /* border: 1px solid red; */
}

.register-page-component-container .form-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    /* border: 1px solid red; */
}

.register-page-component-container .register-form {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    /* border: 1px solid blue; */
}

.register-page-component-container .info-text-container {
    width: 100%;
    max-width: 300px;
    padding: calc(11%) 0 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* border: 1px solid red; */
}

.register-page-component-container .info-text-container .info-text {
    font-size: 30px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #a0a1a3;
    text-align: center;
    line-height: 35px;
    /* border: 1px solid red; */
    /* padding-bottom: 2px; */
}

.register-page-component-container .info-text-container .user-email {
    /* padding: 15px 0 10px 0; */
    /* text-align: center; */
    width: 100%;
    font-family: 'Open Sans Std', sans-serif;
    font-size: 19px;
    word-wrap: break-word;
    text-align: center;
    /* padding-bottom: 3px; */
    /* border: 1px solid red; */
}

.register-page-component-container .input-container {
    width: 100%;
    height: 70px;
    /* padding: 15px 0 20px; */
    /* border: 1px solid red; */
}

/* .email-input-container, */
.register-page-component-container .input-container:nth-of-type(4) {
    height: 65px;
}

.register-page-component-container .form-input {
    width: 100%;
    padding: 8px 6px 6px 8px;
    font-family: 'Open Sans Std', sans-serif;
    font-size: 16px;
    border: 1px solid #92d400;
    border-radius: 10px;
    color: #000000;
    display: inline-block;
    /* margin-bottom: 15px; */
}

.register-page-component-container .form-input:focus {
    outline: 1px solid #92d400;
}

.register-page-component-container .error-msg-unknown-email-container {
    padding: 2px 8px;
    font-size: 12px;
    font-family: 'Open Sans Std', sans-serif;
}

.register-page-component-container .password-section-container {
    position: relative;
    /* border: 1px solid red; */
}

.register-page-component-container .show-hide-password-container {
    position: absolute;
    right: 10px;
    top: 15%;
    bottom: 15%;
    width: 25px;
    display: flex;
    cursor: pointer;
    /* border: 1px solid; */
}

[dir="rtl"] .register-page-component-container .show-hide-password-container {
  right: auto;
  left: 10px;
}

.register-page-component-container .show-hide-password-container img {
    width: 100%;
}

.register-page-component-container input::placeholder,
.register-page-component-container textarea::placeholder {
    color: #a0a1a3;
}

.register-page-component-container .error-msg-password-not-match-container,
.register-page-component-container .password-length-strength-msg-container,
.register-page-component-container .register-info-msg-container {
    padding: 4px 8px;
    font-size: 12px;
    font-family: 'Open Sans Std', sans-serif;
}

.register-page-component-container .error-unknown-email,
.register-page-component-container .error-password-not-match,
.register-page-component-container .error-password-length {
    border: 1px solid #cb061d;
}

.register-page-component-container .error-unknown-email:focus,
.register-page-component-container .error-password-not-match:focus,
.register-page-component-container .error-password-length:focus {
    outline: 1px solid #cb061d;
}

.register-page-component-container .weak {
    border: 1px solid #cb061d;
    /* color: #cb061d; */
}

.register-page-component-container .weak:focus {
    outline: 1px solid #cb061d;
}

.register-page-component-container .medium:focus {
    outline: 1px solid #009df4;
}

.register-page-component-container .strong:focus {
    outline: 1px solid #92d400;
}

.register-page-component-container .medium {
    border: 1px solid #009df4;
}

.register-page-component-container .strong {
    border: 1px solid #92d400;
}

.register-page-component-container .register-btn-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    height: 75px;
    /* border: 1px solid red; */
}

.register-page-component-container .register-btn-wrapper {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* padding: 10px 0 10px 0; */
    /* width: 170px;
    height: 42px; */
    /* background: #92d400; */
    /* border-radius: 30px; */
    /* margin-top: 35px; */
    /* border: 1px solid red; */
}

.register-page-component-container .register-btn {
    /* width: 100%; */
    background: #92d400;
    color: #ffffff;
    font-family: 'VAG Rounded Std', sans-serif;
    font-size: 29px;
    border: none;
    border-radius: 30px;
    cursor: pointer;
    padding: 7px 50px;
    /*  */
    /* padding: 2px 0; */
    /* padding: 3px 0 6px; */
    /* border: 1px solid red; */
}

[dir="rtl"] .register-page-component-container .register-btn {
    font-size: min(26px, calc(14px + 2vw));
    padding: 4px 50px;
}

.register-page-component-container .loading-spinner-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    /* border: 1px solid red; */
}

.register-page-component-container .register-info-msg-container {
    /* height: 20px; */
    text-align: center;
}

.register-page-component-container .can-not-register-text-container {
    /* flex: 0.13; */
    display: flex;
    flex-direction: column;
    /* justify-content: start; */
    align-items: center;
    padding-top: 5px;
    /* padding-bottom: 25px; */
    /* border: 1px solid red; */
}

.register-page-component-container .can-not-register-text-container p {
    color: #616365;
    font-family: 'Open Sans Std', sans-serif;
    font-size: 16px;
    text-align: center;
}

.register-page-component-container .back-to-login-page-container {
    padding-top: 10px;
    padding-bottom: 25px;
}

.register-page-component-container .back-to-login-page-container p {
    color: #616365;
    font-family: 'Open Sans Std', sans-serif;
    font-size: 16px;
    text-align: center;
}

.register-page-component-container .back-to-login-page-btn-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.register-page-component-container .back-to-login-page-btn-container p {
    color: #009df4;
    cursor: pointer;
}

.register-page-component-container .registration-completed-container {
    flex: 1;
    width: 100%;
    max-width: 450px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 25px;
    /* border: 1px solid red; */
}

.register-page-component-container .registration-completed-msg-container {
    flex: 2;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 25px;
    /* border: 1px solid; */
}

.register-page-component-container .registration-completed-msg-container p {
    font-size: 30px;
    font-family: 'VAG Rounded Std', sans-serif;

    color: #a0a1a3;
    text-align: center;
    line-height: 35px;
}

.register-page-component-container .login-btn-container {
    flex: 1.5;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Open Sans Std', sans-serif;
}

.register-page-component-container .login-btn-container p {
    color: #616365;
    padding: 5px 0;
}

.register-page-component-container .login-btn {
    width: 50%;
    min-width: 200px;
    color: #fff;
    font-family: 'VAG Rounded Std', sans-serif;
    font-size: 28px;
    text-align: center;
    letter-spacing: 1px;
    padding: 6px 0 10px;
    background: #009df4;
    border: 1px solid #fff;
    border-radius: 30px;
    cursor: pointer;
}

@media (max-width: 425px) {
    .register-page-component-container .form-input {
        font-size: calc(10px + 0.8vw);
    }

    .register-page-component-container .error-msg-unknown-email-container {
        font-size: calc(6px + 1.2vw);
    }

    .register-page-component-container .error-msg-password-not-match-container,
    .register-page-component-container .password-length-strength-msg-container,
    .register-page-component-container .register-info-msg-container {
        font-size: 11px;
    }

    .register-page-component-container .register-btn {
        font-size: 22px;
    }

    .register-page-component-container .can-not-register-text-container p {
        font-size: 14px;
    }

    .register-page-component-container .registration-completed-msg-container p {
        font-size: 20px;
    }

    .register-page-component-container .login-btn-container p {
        font-size: 14px;
        padding: 10px 0;
    }

    .register-page-component-container .registration-completed-msg-container p {
        font-size: 26px;
    }

    .register-page-component-container .login-btn-container p {
        font-size: 15px;
    }

    .register-page-component-container .login-btn {
        font-size: 24px;
    }
}

@media (max-width: 375px) {
    .register-page-component-container .form-input {
        font-size: calc(6px + 1.3vw);
    }
}

@media (max-width: 320px) {
    .register-page-component-container .info-text-container .info-text {
        font-size: 24px;
    }

    .register-page-component-container .form-input {
        font-size: calc(7px + 1.5vw);
    }

    .register-page-component-container .error-msg-password-not-match-container,
    .register-page-component-container .password-length-strength-msg-container,
    .register-page-component-container .register-info-msg-container {
        font-size: calc(6px + 1.2vw);
    }

    .register-page-component-container .register-btn {
        font-size: 22px;
    }

    .register-page-component-container .can-not-register-text-container p {
        font-size: calc(8px + 1.5vw);
    }

    .register-page-component-container .registration-completed-msg-container p {
        font-size: 20px;
    }

    .register-page-component-container .login-btn-container p {
        font-size: 14px;
        padding: 10px 0;
    }

    .register-page-component-container .login-btn {
        width: 75%;
        max-width: 175px;
        min-width: 0;
        font-size: 20px;
    }
}
</style>